'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SettingsButton = require('./components/SettingsButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SettingsButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/settings-button/index.js
// module id = 925
// module chunks = 0